<sgt-modal [settings]="settings">
  <div body class="file-picker">
    <div class="file-picker__header">
      <span class="file-picker__brand" aria-hidden="true">
        <i class="far fa-folder-open"></i>
      </span>
      <div class="file-picker__heading">
        <p class="file-picker__title">Anexos desta conversa</p>
        <p class="file-picker__subtitle">
          Reaproveite um arquivo já enviado ou gerado aqui
        </p>
      </div>
      <button
        type="button"
        class="file-picker__close"
        aria-label="Fechar"
        (click)="close()"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="file-picker__filters">
      <div class="file-picker__search">
        <i class="fas fa-search" aria-hidden="true"></i>
        <input
          type="text"
          placeholder="Buscar arquivo..."
          aria-label="Buscar arquivo"
          [(ngModel)]="query"
        />
      </div>
    </div>

    <div class="file-picker__list">
      <div
        class="file-picker__row"
        [class.file-picker__row--selected]="isSelected(file)"
        [class.file-picker__row--blocked]="isBlocked(file)"
        [attr.title]="hintFor(file) || null"
        *ngFor="let file of visibleFiles"
        (click)="onFileClick(file)"
      >
        <span
          class="file-picker__icon"
          [style.background]="file.iconBg"
          [style.color]="file.iconColor"
          aria-hidden="true"
        >
          <i [class]="file.icon"></i>
        </span>

        <div class="file-picker__text">
          <div class="file-picker__name">{{ file.name }}</div>
          <div class="file-picker__meta">{{ file.meta }}</div>
        </div>

        <span
          class="file-picker__box"
          [class.file-picker__box--on]="isSelected(file)"
        >
          <i class="fas fa-check" *ngIf="isSelected(file)"></i>
        </span>
      </div>

      <div class="file-picker__empty" *ngIf="isEmpty">
        <i class="fas fa-search" aria-hidden="true"></i>
        <p>Nenhum arquivo encontrado</p>
      </div>
    </div>

    <div class="file-picker__footer">
      <span class="file-picker__count">{{ countLabel }}</span>
      <button type="button" class="file-picker__btn" (click)="close()">
        Cancelar
      </button>
      <button
        type="button"
        class="file-picker__btn file-picker__btn--primary"
        [disabled]="!selection.length"
        (click)="confirm()"
      >
        <i class="fas fa-paperclip" aria-hidden="true"></i>
        Anexar
      </button>
    </div>
  </div>
</sgt-modal>
